// Contracts module (CLM). Everything of the module lives in this folder, so it can be copied as it is into
// another Absat app (apps-web-absat-v2). See INTEGRATION.md for the steps. In short, the host app:
//   1. i18n: registerContractsTranslations(i18next) (the "contracts" namespace);
//   2. routes: <Route path=":tenant/contracts/*" element={<ContractsModule />} />;
//   3. menu: the items of `contractsMenu` (paths relative to /{tenant}/contracts);
//   4. env: REACT_APP_CONTRACTS_API_BASE_URL, REACT_APP_UPLOADS_API_BASE_URL, REACT_APP_INV_API_SERVER_BASE_URL (currencies).
// The only piece it takes from the host is hooks/useCurrent (tenant, company, branch, user), the same hook
// as in the sales app and apps-web-absat-v2.
import ar from './translations/ar.json';
import en from './translations/en.json';
import './shared/module-base.css';
import './contracts.css';

export { default as ContractsModule } from './ContractsModule';
export { default as ContractsSettingsPanel } from './ContractsSettingsPanel';
export { contractsSettingsSections } from './pages/settingsSections';
export { CONTRACTS_BASE_PATH, CONTRACTS_PAGES } from './constants/routes';
export { contractsMenu } from './constants/menu';

export const CONTRACTS_NAMESPACE = 'contracts';

export const contractsTranslations = { ar, en };

// Adds the "contracts" namespace to the host's i18next (before or after its init).
export const registerContractsTranslations = (i18n) => {
    Object.entries(contractsTranslations).forEach(([lang, resources]) => {
        i18n.addResourceBundle(lang, CONTRACTS_NAMESPACE, resources, true, true);
    });
};
